import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const DangerouslySetInnerHtml = forwardRef(({ html, element: Component = 'div', className, onClick, children }, ref) => html ? (jsx(Component, Object.assign({}, {
    ref,
    dangerouslySetInnerHTML: { __html: html },
    className,
    onClick,
    children,
}))) : null);

export { DangerouslySetInnerHtml };
